/* NutraBlast v2 — camada aditiva de comportamento.
   Roda JUNTO com o nutrablast.js base (que segue cuidando de carrinho AJAX,
   marquees, nav mobile e reveal). Aqui: toast, fly-to-cart, cascata cleanup,
   FAQ v2 suave e sticky add-to-cart mobile. */
(function () {
  'use strict';

  if (window.__nutrablastV2Init) return;
  window.__nutrablastV2Init = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- toast */
  var toastEl = null;
  var toastTimer = null;

  function showToast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'nb-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.remove('is-on');
    void toastEl.offsetWidth;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2400);
  }

  // O nutrablast.js base dispara este evento após o /cart/add.js dar certo.
  document.addEventListener('nb:cart:added', function () {
    showToast(window.NB_TOAST_TEXT || 'Added to cart ✓');
  });

  /* ---------------------------------------------------------- fly-to-cart */
  function flyToCart(img) {
    var cart = document.querySelector('.nav__cart');
    if (!cart || !img) return;
    var r = img.getBoundingClientRect();
    var c = cart.getBoundingClientRect();
    if (!r.width || !c.width) return;

    var ghost = document.createElement('img');
    ghost.src = img.currentSrc || img.src;
    ghost.className = 'nb-fly';
    ghost.style.left = r.left + 'px';
    ghost.style.top = r.top + 'px';
    ghost.style.width = r.width + 'px';
    ghost.style.height = r.height + 'px';
    document.body.appendChild(ghost);

    // Força o navegador a registrar o estado inicial antes do destino —
    // sem isso a transição não dispara e o clone "teleporta".
    void ghost.offsetWidth;

    var dx = (c.left + c.width / 2) - (r.left + r.width / 2);
    var dy = (c.top + c.height / 2) - (r.top + r.height / 2);
    ghost.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.08)';
    ghost.style.opacity = '.25';

    setTimeout(function () { ghost.remove(); }, 900);
  }

  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    var card = btn.closest('.product, .mini, [data-nb-sticky]');
    var img = card ? card.querySelector('img') : null;
    if (img && !reduceMotion) flyToCart(img);
    // Botão sem variante configurada não passa pelo AJAX do base — o toast
    // sai daqui para manter o feedback.
    if (!btn.getAttribute('data-variant-id')) {
      showToast(window.NB_TOAST_TEXT || 'Added to cart ✓');
    }
  });

  /* -------------------------------------------- cascata: limpeza pós-reveal */
  // O CSS v2 põe transition-delay escalonado nos itens .reveal-ready dos
  // grids. Ao fim do fade, remove a classe para o delay (e a transição lenta
  // do reveal) não afetarem os hovers do card.
  document.addEventListener('transitionend', function (e) {
    var el = e.target;
    if (!(el instanceof Element)) return;
    if (e.propertyName !== 'opacity') return;
    if (el.classList.contains('reveal-ready') && el.classList.contains('is-visible')) {
      el.classList.remove('reveal-ready');
    }
  });

  /* ------------------------------------------------------------- FAQ v2 */
  // Acordeão de item único com animação de altura (grid-rows no CSS).
  document.querySelectorAll('[data-nb-faq]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq__item');
      if (!item) return;
      var scope = btn.closest('[data-nb-faq-list]') || document;
      var willOpen = !item.classList.contains('is-open');

      scope.querySelectorAll('[data-nb-faq]').forEach(function (other) {
        other.setAttribute('aria-expanded', 'false');
        var otherItem = other.closest('.faq__item');
        if (otherItem) otherItem.classList.remove('is-open');
      });

      if (willOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ------------------------------------- títulos palavra por palavra */
  // Fatia os títulos em spans .nb-w preservando spans internos (.accent).
  // O aria-label mantém o texto íntegro para leitores de tela.
  function splitWords(el) {
    var count = 0;
    el.setAttribute('aria-label', el.textContent.replace(/\s+/g, ' ').trim());
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var frag = document.createDocumentFragment();
          child.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) {
              frag.appendChild(document.createTextNode(part));
            } else {
              var s = document.createElement('span');
              s.className = 'nb-w';
              s.setAttribute('aria-hidden', 'true');
              s.style.setProperty('--i', count++);
              s.textContent = part;
              frag.appendChild(s);
            }
          });
          node.replaceChild(frag, child);
        } else if (child.nodeType === 1) {
          walk(child);
        }
      });
    })(el);
    return count;
  }

  if (!reduceMotion) {
    var titles = document.querySelectorAll(
      '.hero__title, .section-title, .founder__title, .quiz__title, .ugc__title, .newsletter__title, .standards__title'
    );
    var titleIO = ('IntersectionObserver' in window)
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('nb-words-play');
            titleIO.unobserve(entry.target);
          });
        }, { threshold: 0.4 })
      : null;

    titles.forEach(function (t) {
      if (!splitWords(t)) return;
      if (!titleIO || t.getBoundingClientRect().top < window.innerHeight * 0.92) {
        t.classList.add('nb-words-play');
      } else {
        titleIO.observe(t);
      }
    });
  }

  /* ------------------------------------------- tilt 3D nos cards */
  if (!reduceMotion && window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('.product, .mini').forEach(function (card) {
      var media = card.querySelector('.product__media, .mini__media');
      if (!media) return;
      media.classList.add('nb-tilt-media');
      card.style.perspective = '900px';

      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        media.style.transform = 'rotateX(' + (-y * 6).toFixed(2) + 'deg) rotateY(' + (x * 6).toFixed(2) + 'deg)';
      });
      card.addEventListener('mouseleave', function () {
        media.style.transform = '';
      });
    });
  }

  /* ------------------------------------ barra de progresso de leitura */
  // Elemento injetado; a animação é 100% CSS (animation-timeline: scroll()).
  // Sem suporte do navegador, fica invisível.
  var progress = document.createElement('div');
  progress.className = 'nb-progress';
  progress.setAttribute('aria-hidden', 'true');
  document.body.appendChild(progress);

  /* --------------------------------------- marquee genérico (press v2) */
  // Duplica o conteúdo (já em 2 metades vindas do Liquid) até a metade
  // cobrir a viewport — mesma garantia do carrossel e do announcement.
  document.querySelectorAll('[data-nb-marquee]').forEach(function (tr) {
    if (tr.dataset.nbFilled) return;
    tr.dataset.nbFilled = 'true';
    if (!tr.children.length || !tr.scrollWidth) return;
    var guard = 0;
    while (tr.scrollWidth / 2 < window.innerWidth && guard < 6) {
      Array.prototype.slice.call(tr.children).forEach(function (child) {
        var clone = child.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        tr.appendChild(clone);
      });
      guard++;
    }
  });

  /* ------------------------------- reflexo segue-mouse nos CTAs */
  if (window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('.btn--primary, .btn--add, .btn--invert').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        btn.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        btn.style.setProperty('--my', (e.clientY - r.top) + 'px');
      });
    });
  }

  /* --------------------------------------- header inteligente no scroll */
  var header = document.querySelector('.header');
  if (header) {
    var lastY = window.scrollY;
    var onHeaderScroll = function () {
      var y = window.scrollY;
      header.classList.toggle('nb-header--scrolled', y > 8);
      var menuOpen = document.querySelector('.nav__links.is-open');
      if (!menuOpen && y > 160 && y > lastY + 4) {
        header.classList.add('nb-header--hidden');
      } else if (y < lastY - 4 || y <= 160) {
        header.classList.remove('nb-header--hidden');
      }
      lastY = y;
    };
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    onHeaderScroll();
  }

  /* ------------------------------------- indicador de scroll no hero */
  var heroCueHost = document.querySelector('.hero');
  if (heroCueHost && !reduceMotion) {
    var cue = document.createElement('div');
    cue.className = 'nb-scrollcue';
    cue.setAttribute('aria-hidden', 'true');
    cue.innerHTML = '<span class="nb-scrollcue__mouse"><span></span></span>';
    heroCueHost.appendChild(cue);
    var onCueScroll = function () {
      cue.classList.toggle('is-gone', window.scrollY > 80);
    };
    window.addEventListener('scroll', onCueScroll, { passive: true });
    onCueScroll();
  }

  /* ------------------------------------------- ripple no toque (botões) */
  if (!reduceMotion) {
    document.addEventListener('pointerdown', function (e) {
      if (!(e.target instanceof Element)) return;
      var btn = e.target.closest('.btn');
      if (!btn) return;
      var r = btn.getBoundingClientRect();
      var d = Math.max(r.width, r.height);
      var ripple = document.createElement('span');
      ripple.className = 'nb-ripple';
      ripple.setAttribute('aria-hidden', 'true');
      ripple.style.width = ripple.style.height = d + 'px';
      ripple.style.left = (e.clientX - r.left - d / 2) + 'px';
      ripple.style.top = (e.clientY - r.top - d / 2) + 'px';
      btn.appendChild(ripple);
      setTimeout(function () { ripple.remove(); }, 650);
    });
  }

  /* ----------------------------------------- count-up nos números-prova */
  // "4.8", "150,000+ reviews", "24,000+ five-star routines"… sobem do zero
  // quando entram na tela, preservando separadores, decimais e sufixo.
  function animateCount(el) {
    var m = el.textContent.match(/^([\d.,]+)(.*)$/);
    if (!m) return;
    var raw = m[1];
    var suffix = m[2] || '';
    var hasSep = raw.indexOf(',') > -1;
    var decimals = (raw.split('.')[1] || '').length;
    var target = parseFloat(raw.replace(/,/g, ''));
    if (isNaN(target)) return;
    var duration = 1200;
    var start = null;

    function frame(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      p = 1 - Math.pow(1 - p, 3);
      var val = target * p;
      var out = decimals ? val.toFixed(decimals) : Math.round(val).toString();
      if (hasSep) out = out.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      el.textContent = out + suffix;
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  if (!reduceMotion && 'IntersectionObserver' in window) {
    var countEls = document.querySelectorAll('.hero__rating-text strong, .carousel__meta');
    var countIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        countIO.unobserve(entry.target);
        animateCount(entry.target);
      });
    }, { threshold: 0.6 });
    countEls.forEach(function (el) { countIO.observe(el); });
  }

  /* ------------------------------------ Scroll Show: deslize horizontal */
  // A seção .scrollshow tem altura de N painéis; o pin fica sticky e o
  // progresso do scroll vertical dentro dela vira translateX na trilha.
  // Motor em JS + rAF: funciona em qualquer navegador, sem depender de
  // scroll-driven animations.
  if (!reduceMotion) {
    document.querySelectorAll('.scrollshow').forEach(function (show) {
      var track = show.querySelector('.scrollshow__track');
      if (!track) return;
      var bar = show.querySelector('.scrollshow__progress span');
      var ticking = false;

      function update() {
        ticking = false;
        var rect = show.getBoundingClientRect();
        var range = rect.height - window.innerHeight;
        if (range <= 0) return;
        var p = Math.min(1, Math.max(0, -rect.top / range));
        var dist = Math.max(0, track.scrollWidth - window.innerWidth);
        track.style.transform = 'translate3d(' + (-p * dist).toFixed(1) + 'px, 0, 0)';
        if (bar) bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      }

      function requestTick() {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      }

      window.addEventListener('scroll', requestTick, { passive: true });
      window.addEventListener('resize', requestTick);
      update();
    });
  }

  /* ------------------------------ "adesivo assentando" (scroll-linked) */
  // Painéis grandes entram ocupando a largura toda com cantos retos e,
  // conforme o scroll desce, encolhem até o tamanho final ganhando o raio
  // original — reversível ao subir. Progresso amarrado à posição na tela.
  if (!reduceMotion) {
    var settleTargets = [];
    document.querySelectorAll('.standards, .quiz__panel, .press__inner').forEach(function (el) {
      el.classList.add('nb-settle-target');
      settleTargets.push({
        el: el,
        radius: parseFloat(getComputedStyle(el).borderTopLeftRadius) || 0
      });
    });

    if (settleTargets.length) {
      var settleTicking = false;
      var easeOutCubic = function (t) { return 1 - Math.pow(1 - t, 3); };

      var settleUpdate = function () {
        settleTicking = false;
        var vh = window.innerHeight;
        var vw = window.innerWidth;
        settleTargets.forEach(function (item) {
          var rect = item.el.getBoundingClientRect();
          if (rect.top > vh || rect.bottom < 0) return;
          // 0 = topo do painel entrando embaixo; 1 = painel 65% acima → assentado.
          var p = Math.min(1, Math.max(0, (vh - rect.top) / (vh * 0.65)));
          var e = easeOutCubic(p);
          var maxScale = Math.min(vw / (item.el.offsetWidth || vw), 1.15);
          var s = maxScale + (1 - maxScale) * e;
          item.el.style.transform = 'scale(' + s.toFixed(4) + ')';
          item.el.style.borderRadius = (item.radius * e).toFixed(1) + 'px';
        });
      };

      var settleRequest = function () {
        if (!settleTicking) {
          settleTicking = true;
          requestAnimationFrame(settleUpdate);
        }
      };

      window.addEventListener('scroll', settleRequest, { passive: true });
      window.addEventListener('resize', settleRequest);
      settleUpdate();
    }
  }

  /* ---------------------------------------------------- sticky CTA mobile */
  var sticky = document.querySelector('[data-nb-sticky]');
  if (sticky) {
    var setShown = function (on) { sticky.classList.toggle('is-shown', on); };
    var hero = document.querySelector('.hero');

    if (hero && 'IntersectionObserver' in window) {
      // Mostra quando o hero já passou (acima da viewport); esconde de volta no topo.
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          setShown(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
        });
      }).observe(hero);
    } else {
      var onScroll = function () { setShown(window.scrollY > 560); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }
})();
